export { Subtitle2, subtitle2ClassNames } from './components/presets/Subtitle2/index';
